export enum PartnerMarketingImages {
    Agoda = "https://cdn0.agoda.net/images/agoda-homes/partner-marketing/footer-section/agoda_dark_logo.png",
    Priceline = "https://cdn0.agoda.net/images/agoda-homes/partner-marketing/footer-section/priceline_light_logo.png",
    Kayak = "https://cdn0.agoda.net/images/agoda-homes/partner-marketing/footer-section/kayak_light_logo.png",
    BCom = "https://cdn0.agoda.net/images/agoda-homes/partner-marketing/footer-section/bcom_dark_mono_logo.png",
    OpenTable = "https://cdn0.agoda.net/images/agoda-homes/partner-marketing/footer-section/opentable_dark_logo.png",
}
